import { render, staticRenderFns } from "./ChosenResponse.vue?vue&type=template&id=1a3d6d92&"
import script from "./ChosenResponse.vue?vue&type=script&lang=js&"
export * from "./ChosenResponse.vue?vue&type=script&lang=js&"
import style0 from "./ChosenResponse.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports